'use strict';

var _defineProperty = require('@babel/runtime/helpers/defineProperty');

var React = require('react');

var injectSheet = require('react-jss');

var classNames = require('classnames');

var pageMonster = require('pobble-components/dist/full-page-error/page-monster.png');

var pageMonsterGuard = require('pobble-components/dist/full-page-error/page-monster-guard.png');

var pageMonsterUnplug = require('pobble-components/dist/full-page-error/page-monster-unplug.png');

var THEME = require('pobble-components/dist/theme');

var jssMixins = require('pobble-components/dist/jss-mixins');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var _defineProperty__default =
/*#__PURE__*/
_interopDefaultLegacy(_defineProperty);

var React__default =
/*#__PURE__*/
_interopDefaultLegacy(React);

var injectSheet__default =
/*#__PURE__*/
_interopDefaultLegacy(injectSheet);

var classNames__default =
/*#__PURE__*/
_interopDefaultLegacy(classNames);

var pageMonster__default =
/*#__PURE__*/
_interopDefaultLegacy(pageMonster);

var pageMonsterGuard__default =
/*#__PURE__*/
_interopDefaultLegacy(pageMonsterGuard);

var pageMonsterUnplug__default =
/*#__PURE__*/
_interopDefaultLegacy(pageMonsterUnplug);

var THEME__default =
/*#__PURE__*/
_interopDefaultLegacy(THEME);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var COLORS = THEME__default["default"].COLORS,
    FONT_SIZES = THEME__default["default"].FONT_SIZES;
var FullPageError = injectSheet__default["default"]({
  container: _objectSpread(_objectSpread({}, jssMixins.fullVHExceptHeader), {}, {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
  }),
  holder: _defineProperty__default["default"]({
    display: 'flex',
    alignItems: 'center'
  }, "@media (max-width: 1023px)", {
    flexDirection: 'column'
  }),
  img: _defineProperty__default["default"]({
    width: '320px',
    height: 'auto',
    margin: '0 0 0 50px'
  }, "@media (max-width: 1023px)", {
    margin: '0',
    order: '1',
    width: '250px',
    height: 'auto'
  }),
  descHolder: _objectSpread(_objectSpread({
    color: COLORS.TEXT.DARK_GREY.NORMAL
  }, FONT_SIZES.BODY_LARGE.STYLE), {}, _defineProperty__default["default"]({
    textAlign: 'center',
    maxWidth: '300px'
  }, "@media (max-width: 1023px)", {
    order: '2'
  })),
  title: _objectSpread(_objectSpread({
    color: COLORS.DARK_BLUE.NORMAL,
    fontWeight: 'bold'
  }, FONT_SIZES.HEADING_LARGE.STYLE), {}, {
    margin: '0 0 12px'
  }),
  paragraph: {
    margin: '0 0 18px'
  },
  status: {
    position: 'absolute',
    right: '20px',
    top: '20px',
    fontSize: '100px',
    fontWeight: 'bold',
    lineHeight: '1',
    margin: '0',
    color: '#ddd'
  }
})(function (_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      title = _ref.title,
      desc = _ref.desc,
      button = _ref.button,
      status = _ref.status,
      monster = _ref.monster;
  var img = pageMonster__default["default"];

  if (monster === 'guard') {
    img = pageMonsterGuard__default["default"];
  }

  if (monster === 'unplug') {
    img = pageMonsterUnplug__default["default"];
  }

  return (
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      className: classNames__default["default"](classes.container, className)
    },
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      className: classes.holder
    },
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      className: classes.descHolder
    },
    /*#__PURE__*/
    React__default["default"].createElement("h2", {
      className: classes.title
    }, title),
    /*#__PURE__*/
    React__default["default"].createElement("p", {
      className: classes.paragraph
    }, desc), button, status &&
    /*#__PURE__*/
    React__default["default"].createElement("p", {
      className: classes.status
    }, status)), img &&
    /*#__PURE__*/
    React__default["default"].createElement("img", {
      className: classes.img,
      src: img,
      alt: "Page monster Wally"
    })))
  );
});
module.exports = FullPageError;